import { Grid } from '@mui/material'
import { CustomSelect, selectTypes } from 'src/consumer/components/helperComponents'
import PrescriptionSectionCard from './PrescriptionSectionCard'
import {
  PRESCRIPTION_LAYOUTS_ARRAY,
  PRESCRIPTION_PRINT_TYPES_ARRAY,
} from 'src/consumer/constants'

/**
 * Section for prescription layout and print type configuration
 * Handles language, layout type, and print types for doctor and patients
 */
export default function PrescriptionLayoutSection({
  prescriptionTemplate,
  handleChange,
  customOptions,
  disabled,
}) {
  return (
    <PrescriptionSectionCard heading="Layout & print type">
      <Grid item xs={12}>
        <CustomSelect
          id="preferredLanguage"
          value={prescriptionTemplate?.preferredLanguage}
          options={customOptions?.appLanguages?.sort((a, b) =>
            a?.language.localeCompare(b?.language),
          )}
          onChangeEvent={handleChange}
          label="Preferred Language"
          subLabel="Select the language in which the prescription will be printed"
          disabled={disabled}
          getOptionValue={(option) => option?.id}
          getOptionLabel={(option) => option?.language}
          selectType={selectTypes.string}
        />
      </Grid>
      <Grid item xs={12}>
        <CustomSelect
          id="layout"
          value={prescriptionTemplate?.layout}
          options={PRESCRIPTION_LAYOUTS_ARRAY}
          onChangeEvent={handleChange}
          label="Prescription Layout Type"
          disabled={disabled}
          getOptionValue={(option) => option?.id}
          getOptionLabel={(option) => option?.title}
          selectType={selectTypes.string}
        />
      </Grid>
      <Grid item xs={12}>
        <CustomSelect
          id="doctorPrintType"
          value={prescriptionTemplate?.doctorPrintType}
          options={PRESCRIPTION_PRINT_TYPES_ARRAY}
          onChangeEvent={handleChange}
          label="Prescription Print Type for doctor"
          disabled={disabled}
          getOptionValue={(option) => option?.id}
          getOptionLabel={(option) => option?.title}
          selectType={selectTypes.string}
        />
      </Grid>
      <Grid item xs={12}>
        <CustomSelect
          id="userPrintType"
          value={prescriptionTemplate?.userPrintType}
          options={PRESCRIPTION_PRINT_TYPES_ARRAY}
          onChangeEvent={handleChange}
          label="Prescription Print Type for patients"
          disabled={disabled}
          getOptionValue={(option) => option?.id}
          getOptionLabel={(option) => option?.title}
          selectType={selectTypes.string}
        />
      </Grid>
    </PrescriptionSectionCard>
  )
}
